import React from 'react';
import { Link } from 'react-router-dom';
import team_01 from '../../assets/images/team_01.png'
import team_02 from '../../assets/images/team_02.png'
import team_03 from '../../assets/images/team_03.png'

function Team() {
    return (
        <>
            <section className="row_am experts_team_section">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge">Echipa LUMO</span>
                        <h2>
                            Cunoaște echipa <span>noastră</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100} >
                            <div className="experts_box">
                                <img src={team_01} alt="image" />
                                <div className="text">
                                    <h3>Alex Isac</h3>
                                    <span>Co-Founder &amp; Technical Director</span>
                                    <ul className="social_media">
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-instagram" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={200} >
                            <div className="experts_box">
                                <img src={team_01} alt="image" />
                                <div className="text">
                                    <h3>David Molnar</h3>
                                    <span>Co-Founder &amp; Marketing Director</span>
                                    <ul className="social_media">
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#">
                                                <i className="icofont-instagram" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Team;
